export const validateKey = key => {
    const keys = /^[a-z0-9]+$/i
    return keys.test(String(key).toLowerCase())
}